import React, {Component} from 'react';
import '../../../../styles/Home.css'
import '../../../../styles/Miesieczne.css'
import Button from "react-bootstrap/es/Button";
import Rating from 'react-rating'
import BiletyJednorazoweService from "./BiletyJednorazoweService";
import Dropzone from "react-dropzone";
import BOKService from "../bokComponents/BOKService";
import {NotificationManager} from "react-notifications";

export default class BiletyJednorazoweZglos extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            data2: [],
            dodatkoweUwagi: '',
            komfort: 0,
            czystosc: 0,
            kierowca: 0,
            punktualnosc: 0,
            zdjecie: [],
            wyslana: false,
            zdjecieShow: '',
            zdjecieInvalid: false,
            czystoscInvalid: false,
            komfortInvalid: false,
            kierowcaInvalid: false,
            punktualnoscInvalid: false,
            oceniony: false,
            loading: true
        };

        this.handleDodatkoweUwagi = this.handleDodatkoweUwagi.bind(this);
        this.handleCzystosc = this.handleCzystosc.bind(this);
        this.handleKierowca = this.handleKierowca.bind(this);
        this.handleKomfort = this.handleKomfort.bind(this);
        this.handlePunktualnosc = this.handlePunktualnosc.bind(this)
    }

    componentWillMount() {
        window.scrollTo(0, 0);
        BiletyJednorazoweService.getBilet(this.props.idBi)
            .then(function (response) {
                this.setState({data: response.data.biletPoz[0]});
            }.bind(this));
        if (window.location.href.indexOf('ocena') > -1) {
            BiletyJednorazoweService.getOcena(JSON.parse(sessionStorage.getItem('loggedIn')).idKl, this.props.idKu)
                .then(function (response) {
                    this.setState({
                        data2: response.data,
                        czystosc: response.data.ocena1,
                        komfort: response.data.ocena2,
                        kierowca: response.data.ocena3,
                        punktualnosc: response.data.ocena4,
                        dodatkoweUwagi: response.data.uwagi,
                        oceniony: true,
                        loading: false
                    });
                    BiletyJednorazoweService.getPlik(response.data.idOc)
                        .then(function (res) {
                            this.setState({
                                zdjecie: res.data[0],
                                zdjecieShow: 'data:' + res.data[0].typ + ';base64,' + res.data[0].dane
                            })
                        }.bind(this))
                }.bind(this))
        } else {
            this.setState({loading: false})
        }
    }

    handleDodatkoweUwagi(e) {
        this.setState({dodatkoweUwagi: e.target.value})
    }

    handleCzystosc(e) {
        this.setState({czystosc: e, czystoscInvalid: false})
    }

    handleKomfort(e) {
        this.setState({komfort: e, komfortInvalid: false})
    }

    handleKierowca(e) {
        this.setState({kierowca: e, kierowcaInvalid: false})
    }

    handlePunktualnosc(e) {
        this.setState({punktualnosc: e, punktualnoscInvalid: false})
    }

    onDrop(accepted, rejected) {
        if (rejected.length !== 0) {
            this.setState({zdjecieInvalid: true, zdjecie: '', zdjecieShow: ''})
        } else {
            this.getBase64(accepted);
            this.setState({zdjecieInvalid: false, zdjecie: accepted})
        }
    }

    getBase64(file) {
        let reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload = () => {
            this.setState({zdjecieShow: reader.result})
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    postOcena() {
        let name = '';
        let type = '';
        let size = 0;
        let plik = null;
        if (this.state.zdjecie[0] !== null && this.state.zdjecie[0] !== undefined) {
            plik = this.state.zdjecieShow.substr(this.state.zdjecieShow.indexOf(',') + 1);
            name = this.state.zdjecie[0].name;
            size = this.state.zdjecie[0].size;
            type = this.state.zdjecie[0].type
        }
        BOKService.postOcena(JSON.parse(sessionStorage.getItem('loggedIn')).idKl, this.state.data.idKu,
            this.state.czystosc, this.state.komfort, this.state.kierowca, this.state.punktualnosc,
            this.state.dodatkoweUwagi, plik, name, size, type)
            .then(function (response) {
                if (response.status === 200) {
                    NotificationManager.success("", "Ocena została wysłana ", 5000);

                    this.setState({
                        wyslana: true
                    })
                }
            }.bind(this))
            .catch((e) => {
                if (e.response.status === 409) {
                    NotificationManager.error("", "Podany kurs został już oceniony ", 5000);

                    this.setState({
                        czystosc: 0,
                        komfort: 0,
                        kierowca: 0,
                        punktualnosc: 0,
                        dodatkoweUwagi: '',
                        zdjecieShow: '',
                        zdjecie: []
                    })
                } else {
                    NotificationManager.error("", "Brak połączenia z serwerem ", 5000)
                }
            })
    }

    wyslijUwagi() {
        let czystosc, komfort, kierowca, punktualnosc;
        if (this.state.czystosc === 0) {
            czystosc = true
        }
        if (this.state.komfort === 0) {
            komfort = true
        }
        if (this.state.kierowca === 0) {
            kierowca = true
        }
        if (this.state.punktualnosc === 0) {
            punktualnosc = true
        }
        if (!czystosc && !komfort && !kierowca && !punktualnosc) {
            this.postOcena()
        } else {
            this.setState({
                czystoscInvalid: czystosc,
                komfortInvalid: komfort,
                kierowcaInvalid: kierowca,
                punktualnoscInvalid: punktualnosc
            })
        }
    }

    render() {
        return <div>

            <h4 style={{textAlign: 'center', marginBottom: 20}}>
                <b>{this.state.oceniony ? 'Podgląd oceny przejazdu' : 'Oceń przejazd'}</b></h4>
            <div style={{
                textAlign: 'center',
                fontWeight: 'bold'
            }}>{this.state.data.nazMiOd} - {this.state.data.nazMiDo}
                <i className="fa fa-calendar" style={{marginLeft: 15}}> </i> {this.state.data.waznyOd} <i
                    className="fa fa-clock-o" style={{marginLeft: 15}}> </i> {this.state.data.godz}</div>
            <hr/>
            {this.state.loading ? <div style={{paddingTop: 10, textAlign: 'center', color: '#58b13d'}}>
                    <div className="loaderDim"><i className="fa fa-spinner fa-pulse fa-2x fa-fw"> </i></div>
                </div> :
                <div>
                    {this.state.wyslana ?
                        <div className="text-center" style={{marginTop: 50, marginBottom: 50}}><h2><i
                            className="fa fa-2x fa-check"
                            style={{color: '#58b13d', marginRight: 35}}> </i> Dziękujemy,
                            Twoja ocena została wysłana.</h2></div> : <div className="row" style={{marginTop: 25}}>
                            <div className="col-sm-6 borderRightNoneMobilka"
                                 style={{borderRight: '1px solid #eaeaea'}}>
                                <b>Ocena: <font style={{color: 'red'}}>*</font></b>
                                <div className="row" style={{marginTop: 25}}>
                                    <div className="col-6" style={{lineHeight: '36px'}}>
                                        Czystość
                                    </div>
                                    <div className="col-6">
                                        <Rating
                                            emptySymbol="fa fa-star-o greenStar"
                                            fullSymbol="fa fa-star greenStar"
                                            readonly={this.state.oceniony}
                                            value={this.state.czystosc}
                                            initialRating={this.state.czystosc}
                                            onChange={this.handleCzystosc}
                                        />
                                        {this.state.czystoscInvalid ?
                                            <div className="niepoprawneDaneOsobowe"
                                                 style={{fontSize: '0.875rem'}}>Proszę
                                                wystawić
                                                ocenę.</div> : null}
                                    </div>

                                </div>
                                <div className="row" style={{marginTop: 25}}>
                                    <div className="col-6" style={{lineHeight: '36px'}}>
                                        Komfort
                                    </div>
                                    <div className="col-6">
                                        <Rating
                                            readonly={this.state.oceniony}
                                            emptySymbol="fa fa-star-o greenStar"
                                            fullSymbol="fa fa-star greenStar"
                                            initialRating={this.state.komfort}
                                            value={this.state.komfort}
                                            onChange={this.handleKomfort}
                                        />
                                        {this.state.komfortInvalid ?
                                            <div className="niepoprawneDaneOsobowe"
                                                 style={{fontSize: '0.875rem'}}>Proszę
                                                wystawić
                                                ocenę.</div> : null}
                                    </div>
                                </div>
                                <div className="row" style={{marginTop: 25}}>
                                    <div className="col-6" style={{lineHeight: '36px'}}>
                                        Kierowca
                                    </div>
                                    <div className="col-6">
                                        <Rating
                                            readonly={this.state.oceniony}
                                            emptySymbol="fa fa-star-o greenStar"
                                            fullSymbol="fa fa-star greenStar"
                                            initialRating={this.state.kierowca}
                                            value={this.state.kierowca}
                                            onChange={this.handleKierowca}
                                        />
                                        {this.state.kierowcaInvalid ?
                                            <div className="niepoprawneDaneOsobowe"
                                                 style={{fontSize: '0.875rem'}}>Proszę
                                                wystawić
                                                ocenę.</div> : null}
                                    </div>
                                </div>
                                <div className="row" style={{marginTop: 25}}>
                                    <div className="col-6" style={{lineHeight: '36px'}}>
                                        Punktualność
                                    </div>
                                    <div className="col-6">
                                        <Rating
                                            readonly={this.state.oceniony}
                                            emptySymbol="fa fa-star-o greenStar"
                                            fullSymbol="fa fa-star greenStar"
                                            initialRating={this.state.punktualnosc}
                                            value={this.state.punktualnosc}
                                            onChange={this.handlePunktualnosc}
                                        />
                                        {this.state.punktualnoscInvalid ?
                                            <div className="niepoprawneDaneOsobowe"
                                                 style={{fontSize: '0.875rem'}}>Proszę
                                                wystawić
                                                ocenę.</div> : null}
                                    </div>
                                </div>
                                {this.state.oceniony ? <div className="row" style={{marginTop: 100}}>
                                    <div className="col-12">
                                        <small>Oceniono: {this.state.data2.data}</small>
                                    </div>
                                </div> : null}
                            </div>
                            <div className="col-sm-6">
                                <b>Dodatkowe uwagi:</b>
                                <textarea rows={5}
                                          maxLength={120}
                                          disabled={this.state.oceniony}
                                          style={{
                                              background: 'white',
                                              resize: 'none',
                                              marginTop: 10,
                                              width: '100%',
                                              border: '1px solid #e0e0e0',
                                              borderRadius: 5,
                                              padding: 10
                                          }}
                                          placeholder={"Wpisz wiadomość... (maks. 120 znaków)"}
                                          value={this.state.dodatkoweUwagi}
                                          onChange={this.handleDodatkoweUwagi}/>
                                <hr/>
                                <div style={{fontWeight: 'bold', marginTop: 10}}>Zdjęcie:</div>
                                <div className="row" style={{marginTop: 10}}>
                                    <div className="col-12">
                                        {!this.state.oceniony ?
                                            <Dropzone maxSize={2000000} accept="image/jpeg, image/jpg"
                                                      style={{
                                                          maxWidth: '100%',
                                                          height: 150,
                                                          border: '1px dashed #ced4da',
                                                          borderRadius: '0.25rem',
                                                          paddingTop: 15,
                                                          textAlign: 'center',
                                                          fontSize: '0.875rem',
                                                          color: '#565756',
                                                          cursor: 'pointer'
                                                      }}
                                                      onDrop={(accepted, rejected) => {
                                                          this.onDrop(accepted, rejected)
                                                      }}>
                                                {this.state.zdjecieInvalid ? <div>
                                                    <div style={{paddingTop: '10%', color: 'red'}}>Plik zdjęcia jest
                                                        niepoprawny!
                                                    </div>
                                                    <div>(Kliknij by wybrać zdjęcie)</div>
                                                </div> : <div>{this.state.zdjecieShow === '' ? <div>
                                                    <div style={{paddingTop: '10%'}}>Akceptowane pliki .jpg</div>
                                                    <div>Maksymalny rozmiar 2mb</div>
                                                </div> : <div>
                                                    <img src={this.state.zdjecieShow}
                                                         style={{maxWidth: '90%', maxHeight: 100}}/>
                                                    <p>(Kliknij by zmienić zdjęcie)</p>
                                                </div>}</div>}
                                            </Dropzone> : <div style={{
                                                maxWidth: '100%',
                                                height: 150,
                                                border: '1px dashed #ced4da',
                                                borderRadius: '0.25rem',
                                                paddingTop: 15,
                                                textAlign: 'center',
                                                fontSize: '0.875rem',
                                                color: '#565756',
                                            }}>
                                                {this.state.zdjecie !== '' ? <div>
                                                    <img src={this.state.zdjecieShow}
                                                         style={{maxWidth: '90%', maxHeight: 100}}/>
                                                    <p>{this.state.zdjecie.nazwa}</p>
                                                </div> : <div>
                                                    <div style={{paddingTop: '10%'}}>Brak zdjęcia</div>
                                                </div>}
                                            </div>}
                                    </div>
                                </div>
                            </div>
                        </div>}
                    {this.state.oceniony || this.state.wyslana ? null :
                        <div className="row" style={{marginTop: 25}}>
                            <div className="col-sm-12 text-right">
                                <Button bsStyle={'success'} onClick={() => {
                                    this.wyslijUwagi();
                                }}>Wyślij uwagi</Button>
                            </div>
                        </div>}
                </div>}
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/mojeBiletyComponents/BiletyJednorazoweZglos.js